export class SYNC_OPERATION_NAMES {
  static readonly sync = 'Syncing';
  static readonly syncEntity = 'Syncing Entity';
  static readonly discardEntity = 'Discarding Entity';
}
